import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  root: {
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    border: `2px solid transparent`,
    transition: '0.3s',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: theme.palette.action.hover,
    },
  },
  activeRoot: {
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    border: `2px solid ${theme.palette.text.primary}`,
  },

  //Card
  titlePrice: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  socialLink: {
    color: theme.palette.text.primary,
    opacity: 0.54,
    textDecoration: 'underline',
    overflowWrap: 'anywhere',
  },
  titleAndIcon: {
    display: 'flex',
    justifyContent: 'flex-left',
    marginBottom: theme.spacing(0.5),
  },
  title: {
    paddingLeft: theme.spacing(1),
  },
  description: {
    color: theme.palette.text.secondary,
  },

  //icons
  desktopMac: {
    color: '#017676',
  },
  instagram: {
    background: 'linear-gradient(#F214E1,#DDA91E)',
    color: 'white',
    borderRadius: 6,
    height: '0.9em',
    width: '0.9em',
  },
  youtube: {
    color: '#E64444',
  },
}));
